import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";

interface IPositionsDto {
  accessLevelName: string | null;
  updatedAt: number | null;
  createdAt: number | null;
  createdByUserId: string | null;
  deletedAt: number | null;
  id: string | null;
  importId: string | null;
  isDeleted: boolean;
  isForOperation: boolean;
  name: string | null;
  roleId: string | null;
  roleName: string | null;
  updatedByUserId: string | null;
}

export const positionsApi = createApi({
  reducerPath: "positionsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchPositions: builder.query<IPositionsDto[], void>({
      queryFn: pagedQueryFn<IPositionsDto, IPositionsDto[]>(
        { url: "PositionsV2" },
        (dtos) => dtos
      ),
    }),
  }),
});

export const { useFetchPositionsQuery } = positionsApi;
